import PageTitle from '@/components/Admin/PageTitle';
import Table from '@/components/Admin/Table';
import { useQuery } from '@tanstack/react-query';
import React from 'react';

import styled from 'styled-components';
import { colors } from '@/constants/colors';
import { useUIStore } from '@/store/useUIStore';
import { cancelBilling, fetchBilling } from '@/api/billing';
import { toast } from 'react-toastify';

interface TableBilling {
   _id: string;
   store: string;
   subscription: string;
   status: 'pending' | 'success';
   amount: number;
   paymentMethod: 'gcash' | 'bank';
   createdAt: string;
   checkoutUrl: string;
}

type PageTitleActions = {
   type: 'normal' | 'button';
   title: string;
   onClick?: () => void;
};

const Billing = () => {
   const { refresh, handleShow, handleRefresh, handleClose } = useUIStore();

   const {
      data: response,
      isLoading,
      error,
   } = useQuery({
      queryKey: ['billing-list', refresh],
      queryFn: fetchBilling,
   });

   // console.log(`response----`, response);

   const transformedData =
      response?.result?.map((billing: TableBilling) => ({
         ...billing,
         subscription: billing.subscription || 0,
         status: billing.status || 0,
         amount: billing.amount || 0,
      })) || [];

   const billingHeadData = [
      {
         type: 'title',
         value: 'Date',
      },
      {
         type: 'title',
         value: 'Store Name',
      },
      {
         type: 'title',
         value: 'Subscription',
      },
      {
         type: 'title',
         value: 'Status',
      },
      {
         type: 'title',
         value: 'Amount',
      },
      {
         type: 'title',
         value: 'Payment',
      },
      {
         type: 'title',
         value: 'Action',
      },
   ];

   const pageTitleActions: PageTitleActions[] = [];

   const dropdownData = [
      {
         type: 'normal',
         value: 'Proceed',
         icon: 'check-circle-line',
         label: 'Proceed',
         onClick: (item: TableBilling) => {
            window.open(item.checkoutUrl, '_blank');
         },
      },
      {
         type: 'normal',
         value: 'Cancel',
         icon: 'close-line',
         label: 'Cancel',
         onClick: (item: TableBilling) => {
            cancelBilling(item._id)
               .then(() => {
                  toast.success('Billing cancelled successfully');
                  handleRefresh();
               })
               .catch((err) => {
                  console.log(err);
               });
         },
      },
   ];

   return (
      <Wrapper>
         <PageTitle title="Billing" actions={pageTitleActions} />

         {isLoading ? (
            <LoadingText>Loading stores...</LoadingText>
         ) : error ? (
            <ErrorText>Error loading stores: {error.message}</ErrorText>
         ) : (
            <Table<TableBilling>
               headData={billingHeadData}
               data={transformedData}
               grid={`.5fr 1fr 100px 100px 100px 200px auto`}
               type="billing"
               dropdownData={dropdownData}
            />
         )}
      </Wrapper>
   );
};

const Wrapper = styled.div``;
const LoadingText = styled.div`
   text-align: center;
   padding: 2rem;
   color: ${colors.GRAY5};
`;

const ErrorText = styled.div`
   text-align: center;
   padding: 2rem;
   color: ${colors.DANGER};
`;
export default Billing;
